<div class="save-template-dialog">
  <div class="dialog-header">
    <h3 class="dialog-title">{{ (data.title ?? 'Save as Template') | translate }}</h3>
    <button mat-icon-button class="close-button" (click)="cancel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="dialog-body">
    <mat-form-field appearance="outline" class="name-field">
      <mat-label>{{ 'Template Name' | translate }}</mat-label>
      <input
        matInput
        [(ngModel)]="name"
        [placeholder]="'Enter template name' | translate"
        maxlength="255" />
      </mat-form-field>

      @if (data.showShareControl !== false) {
        <app-template-share-control
          [isShared]="isShared"
          [organizationLevelId]="organizationLevelId"
          [dataOrganizationLevelId]="data.dataOrganizationLevelId ?? null"
          [canManage]="true"
          (shareChange)="onShareChange($event)">
        </app-template-share-control>
      }
    </div>

    <div class="dialog-actions">
      <button class="btn cancel-modal-btn" (click)="cancel()">
        {{ 'Cancel' | translate }}
      </button>
      <button class="btn save-modal-btn" [disabled]="!isValid" (click)="confirm()">
        {{ (data.confirmText ?? 'Save Template') | translate }}
      </button>
    </div>
  </div>
